import { createAction } from '@reduxjs/toolkit'
import { AgentQueryResponse } from '../api/agentQuery'

export interface ChatMessage {
  id: string
  role: 'user' | 'agent' | 'error'
  text: string
  timestamp: number
}

export interface SendMessagePayload {
  prompt: string
  sessionId: string | null
}

export interface SessionRestoredPayload {
  sessionId: string
  messages: ChatMessage[]
}

export const sendMessage = createAction<SendMessagePayload>('AGENT_QUERY_SEND')
export const messageReceived = createAction<AgentQueryResponse>('AGENT_QUERY_RECEIVED')
export const messageError = createAction<string>('AGENT_QUERY_ERROR')
export const sessionRestored = createAction<SessionRestoredPayload>('AGENT_QUERY_SESSION_RESTORED')
export const sessionCleared = createAction('AGENT_QUERY_SESSION_CLEARED')
